import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { ServicePrice } from '../types/entities/ServicePrice';

export const servicePrice: SchemaWithClient<ServicePrice> = {
  name: 'Service Price',
  pluralName: 'Service Price',
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      fieldType: 'text',
      readOnly: true,
    },
    up_to_person: {
      name: 'Up To Person',
      fieldRenderer: NumberField,
      fieldType: 'float',
    },
    price: {
      name: 'Price',
      fieldRenderer: NumberField,
      fieldType: 'float',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/service-prices'),
};
